import type { ReactNode } from 'react'
import styles from './ProjectInfoGrid.module.scss'

export interface ProjectInfoItem {
  label: string
  value: ReactNode
}

export interface ProjectInfoGridProps {
  items: ProjectInfoItem[]
}

/**
 * Two-column grid of small KV cards (the "Resolução / FPS / Tamanho / Voz
 * / Música / Última build" row in the design). Caller decides which
 * fields to show — unknown metadata simply isn't passed.
 */
export function ProjectInfoGrid({ items }: ProjectInfoGridProps) {
  if (items.length === 0) return null
  return (
    <div className={styles.grid}>
      {items.map((item) => (
        <div key={item.label} className={styles.cell}>
          <div className={styles.label}>{item.label}</div>
          <div className={styles.value}>{item.value}</div>
        </div>
      ))}
    </div>
  )
}
